import { useContext } from 'react';

import config from 'config';
import { ConfigContext } from '@providers/ConfigProvider';
import Link from '@components/atoms/Link';
import { FormattedMessage } from 'utils/intl';

import messages from './PersonalDataClause.messages';
import classes from './PersonalDataClause.module.scss';

const { routes } = config;

const PersonalDataClause = (): JSX.Element => {
  const { contact } = useContext(ConfigContext);

  const { name, typeOfCompany, addressWithoutCountry, krs, nip } = contact;

  const link = (
    <Link component="span" className={classes.link} href={routes.privacyPolicy.href} openInNewTab>
      <FormattedMessage {...messages.link} />
    </Link>
  );

  return (
    <FormattedMessage {...messages.info} values={{ name, typeOfCompany, addressWithoutCountry, krs, nip, link }} />
  );
};

export default PersonalDataClause;
